module.exports = __webpack_public_path__ + "img/5.3aad6106.jpg";